<template>
    <AuthenticatedLayout
        :title="__('Lottery')"
        :footerContainer="false"
    >
    <div class="max-w-screen-xl w-full mx-auto">

        <div class="relative">
            <div class="bg-white text-gray-900 rounded-md shadow-md flex flex-col">
            <div class="p-8">
                <h2 class="border-b-2 border-red-700 mb-5 pb-4 text-center text-2xl font-bold">{{__(page.title)}}</h2>

                <div class="ql-snow">
                    <div v-html="page.content" class="ql-editor content -mx-4"></div>
                </div>

                <div class="grid grid-cols-2 gap-3 mt-5">
                    <InputLabel
                        id="email"
                        :label="__('Email')"
                        type="email"
                        placeholder="email@email.com"
                        class="block w-full sm:col-span-1 col-span-2"
                        v-model="form.email"
                    />
                    <InputLabel
                        id="order_id"
                        :label="__('Order ID')"
                        placeholder="#00000000"
                        class="block w-full sm:col-span-1 col-span-2"
                        v-model="form.order_id"
                    />
                    <div class="col-span-2">
                        <label for="file" />
                        <input id="file" type="file" @change="ev => {
                            form.file = ev.target.files[0];
                            $page.props.errors.file = null
                        }">
                        <div
                            v-if="checkError($page.props.errors, 'file')"
                            class="text-red-500 text-xs font-bold"
                        >{{checkError($page.props.errors, 'file')}}</div>
                    </div>

                    <div class="space-y-3">
                        <Checkbox
                            id="regulation"
                            :label="__('I accept the lottery :terms_of_use', { terms_of_use: linkGenerate('contest-terms-of-use', __('terms of use'), { blank: true} )})"
                            v-model="form.regulation"
                        ></Checkbox>
                        <Checkbox
                            id="processing_personal_data"
                            :label="__('I have read the :information on the processing of personal data', { information: linkGenerate('processing-of-personal-data', __('information'), { blank: true} )})"
                            v-model="form.processing_personal_data"
                        />
                    </div>
                </div>
                <Button
                    class="font-bold justify-center mt-3"
                    :class="{
                        ['opacity-50'] : !form.regulation || !form.processing_personal_data
                    }"
                    padding="md"
                    color="gray"
                    @click="sendForm"
                >
                    {{__('Send')}}
                </Button>
            </div>
            <div class="p-3 bg-red-800 rounded-b-md text-gray-200 mt-auto">
                <ul class="text-lg py-2">
                    <li>
                        <a class="flex items-center justify-center w-min mx-auto hover:underline" :href="'mailto:' + $page.props.siteData.email">
                        <SvgIcon class="mr-1" name="email"/>
                        {{$page.props.siteData.email}}
                        </a>
                    </li>
                </ul>
            </div>
            </div>
        </div>
    </div>
    </AuthenticatedLayout>
</template>

<script>
import AuthenticatedLayout from '@/Layouts/Authenticated';
import SvgIcon from 'UI/SvgIcon';
import Heading from 'COMP/Heading';
import CustomSelect from 'UI/CustomSelect';
import InputLabel from 'UI/InputLabel';
import Checkbox from 'UI/Checkbox';

import { useForm } from '@inertiajs/inertia-vue3'
import Button from 'UI/Button';

import {
    checkError,
    getFullName,
    linkGenerate
} from 'helper';

export default {
    components: {
        AuthenticatedLayout,
        SvgIcon,
        Heading,
        CustomSelect,
        InputLabel,
        Button,
        Checkbox,
    },
    props: {
        auth: Object,
        loggedin: Boolean,
        page: [Array, Object],
    },
    setup(props) {
        const form = useForm({
            email: props.loggedin ? props.auth.user.email : null,
            order_id: null,
            regulation: false,
            file: null,
            processing_personal_data: false,
        })

        const sendForm = () => {
            form.post(route('lottery.send'), {
                preserveScroll: true,
                onSuccess: () => { form.reset(); }
            });
        }

        return {
            form,
            sendForm,
            checkError,
            getFullName,
            linkGenerate,
        }
    },
}
</script>
